module.exports = __webpack_public_path__ + "assets/img/groups.581304c9.svg";